import { render, staticRenderFns } from "./weeklyFundPlan.vue?vue&type=template&id=33b5dfc9&scoped=true&"
import script from "./weeklyFundPlan.vue?vue&type=script&lang=js&"
export * from "./weeklyFundPlan.vue?vue&type=script&lang=js&"
import style0 from "./weeklyFundPlan.vue?vue&type=style&index=0&id=33b5dfc9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5dfc9",
  null
  
)

export default component.exports